<template>
  <gg-modal :is-active="dialog" @close="close" v-if="id">
    <template v-slot:toolbar>{{ caption }} Request</template>
    <template v-slot:body>
      <p>
        Are you sure you want to {{ actionText }} “{{ requestData.email }}”?
      </p>
    </template>
    <template v-slot:actions>
      <gg-btn secondary @click="close">
        Cancel
        <span class="visually-hidden text-lowercase">button</span>
      </gg-btn>
      <gg-btn :loading="loading" @click="pendingAction">
        {{ caption }}
        <span class="visually-hidden text-lowercase">button</span>
      </gg-btn>
    </template>
  </gg-modal>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import modalMixin from '@/mixins/modal'
import PendingActionsTypes from '@/helpers/profile-access'

export default {
  name: 'PendingActionModal',
  mixins: [modalMixin],
  props: {
    id: {
      type: [Number, String],
      required: true
    },
    actionType: {
      type: String,
      required: true
    },
  },
  data () {
    return {
      loading: false,
    }
  },
  computed: {
    ...mapGetters(['accessPendingList']),
    caption () {
      switch (this.actionType) {
        case PendingActionsTypes.reject:
          return 'Reject'
        case PendingActionsTypes.revoke:
          return 'Revoke'
        case PendingActionsTypes.accept:
          return 'Accept'
        case PendingActionsTypes.resend:
          return 'Resend'
        default: return ''
      }
    },
    requestData () {
      return this.accessPendingList.find(request => request.id == this.id)
    },
    isReceived () {
      return this.requestData.type === 'received'
    },
    actionText () {
      switch (this.actionType) {
        case PendingActionsTypes.reject:
          return 'reject the request from'
        case PendingActionsTypes.revoke:
          return 'revoke your request to'
        case PendingActionsTypes.accept:
          return 'accept the request from'
        case PendingActionsTypes.resend:
          return 'resend the request to'
        default: return ''
      }
    },
  },
  methods: {
    ...mapActions([
      'reportError',
      'reportSuccess',
      'rejectPendingRequest',
      'revokePendingRequest',
      'acceptPendingRequest',
      'resendPendingRequest'
    ]),
    async pendingAction () {
      this.loading = true
      try {
        let response
        switch (this.actionType) {
          case PendingActionsTypes.reject:
            response = await this.rejectPendingRequest(this.id)
            break
          case PendingActionsTypes.revoke:
            response = await this.revokePendingRequest(this.id)
            break
          case PendingActionsTypes.accept:
            response = await this.acceptPendingRequest(this.id)
            break
          case PendingActionsTypes.resend:
            response = await this.resendPendingRequest(this.id)
            break
          default: break
        }
        this.reportSuccess(response.resultmsg)
      } catch (e) {
        this.loading = false
        this.reportError(e)
      }
      this.loading = false
      this.close()
    },
  },
}
</script>
